import { render, staticRenderFns } from "./incl-pharmacy-pwa-config.vue?vue&type=template&id=770286b6&scoped=true"
import script from "./incl-pharmacy-pwa-config.vue?vue&type=script&lang=js"
export * from "./incl-pharmacy-pwa-config.vue?vue&type=script&lang=js"
import style0 from "./incl-pharmacy-pwa-config.vue?vue&type=style&index=0&id=770286b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770286b6",
  null
  
)

export default component.exports